<template>
  <v-btn class="v-secondary-btn" outlined color="secondary" rounded>
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  name: 'VSecondaryBtn',
}
</script>

<style scoped>
.v-secondary-btn {
  font-family: 'Poppins';
  font-weight: 600;
  font-size: 16px;
  letter-spacing: normal;
  color: #12c29b;
  border: 1px solid #12c29b;
}
</style>
